import axios from 'axios';
import config from '@/config';

const baseUrl = `${config.ctx.iffApi}/jxxf/pg`;

export const pgIssueService = {
  page: params => axios.get(`${baseUrl}/issue`, { params }),
  detail: wtId => axios.get(`${baseUrl}/issue/${wtId}`),
  create: data => axios.post(`${baseUrl}/issue`, data),
  update: (wtId, data) => axios.put(`${baseUrl}/issue/${wtId}`, data),
  delete: (wtId, lockVersion) => axios.delete(`${baseUrl}/issue/${wtId}`, { params: { lockVersion } })
};
